import React from "react";
import I18n from "../i18n";

class SaleTicketSvg extends React.Component {
    render() {
        const {
            className = '',
            color = '#000',
            size = '50px',
            tooltip,
            discountText = '50% OFF',
            textColor = '#fff',
            fontSize = '80px',
        } = this.props;

        return (
            <svg
                className={className}
                fill={color}
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 298.333 298.333"
                stroke={color}
            >
                {tooltip && (
                    <title>{tooltip}% {I18n.t('discount')}</title>
                )}

                <g id="SVGRepo_iconCarrier">
                    <g>
                        <path d="m248.833,66.166h-248.833v166h248.833l49.5-83-49.5-83z" />
                    </g>
                </g>

                <text
                    x="50%"
                    y="55%"
                    dominantBaseline="middle"
                    textAnchor="middle"
                    fill={textColor}
                    fontFamily="Arial, sans-serif"
                    fontSize={fontSize}
                    fontWeight="bold"
                >
                    {discountText}
                </text>
            </svg>
        );
    }
}

export default SaleTicketSvg;
